import { useQuery } from "@tanstack/react-query";
import { StatusBadge } from "@/design-system/components/ui";
import { portalAccountsApi } from "@/api/portalAccounts";
import { collectionStagingKeys } from "@/api/collectionStagingKeys";

// Portal-absorption spine (WS-C0) — the per-account needs-attention badge.
// Renders "N need attention" (danger when anything is overdue, warn
// otherwise) from the existing per-account submission summary; renders
// nothing when the account has no pending review work. Keyed under the
// "collection-staging" prefix so review mutations refresh it for free.

export interface NeedsAttentionBadgeProps {
  portalUserId: string | null | undefined;
}

export function NeedsAttentionBadge({ portalUserId }: NeedsAttentionBadgeProps) {
  const summary = useQuery({
    queryKey: collectionStagingKeys.accountSummary(portalUserId ?? ""),
    queryFn: () => portalAccountsApi.submissionSummary(portalUserId!),
    enabled: Boolean(portalUserId),
  });

  const s = summary.data;
  if (!portalUserId || !s || s.totalPendingCount <= 0) return null;

  return (
    <StatusBadge tone={s.overdueCount > 0 ? "danger" : "warn"}>
      {s.totalPendingCount} need{s.totalPendingCount === 1 ? "s" : ""} attention
      {s.overdueCount > 0 ? ` · ${s.overdueCount} overdue` : ""}
    </StatusBadge>
  );
}
